import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./materiaisOrdemCadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { getServicosOrdem } from "../../services/api_servicos_ordem_servicos";
import { getMateriais } from "../../services/api_materiais";
import {
  getMaterialServicoById,
  getMaterialServicoCadastro,
  getMaterialServicoUpdate,
} from "../../services/api_cadastro_material_ordem";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const MateriaisOrdemRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const idServicoOrdem = location.state?.idServicoOrdem;

  const [id_material, setMaterial] = useState("");
  const [id_servico_ordem, setServicoOrdem] = useState("");
  const [quantidade, setQuantidade] = useState("");
  const [servico_ordem, setServicosOrdens] = useState([]);
  const [material, setMateriais] = useState([]);

  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Material: useRef(null),
    Quantidade: useRef(null),
  };

  useEffect(() => {
    const fetchMaterialOrdem = async () => {
      try {
        const response = await getMaterialServicoById(id);
        //console.log("informações id material ordem", response);
        const material_ordem = response.data.MateriaisServico; // Corrigido para acessar response.data.empresa
        if (material_ordem) {
          setServicoOrdem(material_ordem.id_servico_ordem || "");
          setMaterial(material_ordem.id_material || "");
          setQuantidade(material_ordem.quantidade || "");
        } else {
          console.error("Dados não encontrados:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    if (id) {
      fetchMaterialOrdem();
    }
  }, [id]);

  useEffect(() => {
    const fetchServicosOrdem = async () => {
      try {
        const response = await getServicosOrdem();
        //console.log("informações Serviços da Ordem", response);

        if (response) {
          setServicosOrdens(response.data.ServicosOrdem);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchServicosOrdem();
    const interval = setInterval(()=>{
      fetchServicosOrdem();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchMaterial = async () => {
      try {
        const response = await getMateriais();
        //console.log("informações de materiais", response);

        if (response && response.status === 200) {
          const materiaisAtivos = response.data.Materiais.filter((material) => material.deleted_at == null);
          setMateriais(materiaisAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter setores executantes:", error);
      }
    };

    fetchMaterial();
    const interval = setInterval(()=>{
      fetchMaterial()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!id_material || !quantidade) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento de todos os campos é obrigatório.",
      });

      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getMaterialServicoCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar dados:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar dados:", error);
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };
  

  const newUpdate = async (body) => {
    try {
      const response = await getMaterialServicoUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar dados:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar dados:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleQuantidade = (e) => {
    let value = e.target.value;
  
    // Substitui ponto por vírgula para exibição
    value = value.replace('.', ',');
  
    // Verifica se o valor é um número válido ou uma string vazia
    if (/^\d*,?\d*$/.test(value)) {
      setQuantidade(value);
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        id_material,
        id_servico_ordem: idServicoOrdem,
        quantidade: parseFloat(quantidade.replace(',', '.')),
      };
      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === "Enter" && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus =
        nextFieldRef.current.inputRef || nextFieldRef.current;

      if (typeof elementToFocus.focus === "function") {
        elementToFocus.focus();
      } else {
        console.warn("O elemento de input não tem o método focus.");
      }
    }
  };

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="/ Cadastro de Materiais em Ordem de Serviço" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formUniMedida">
                  <Form.Label>Material</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_material}
                    onChange={(e) => setMaterial(e.target.value)}
                    ref={inputRefs.Material}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Quantidade)}
                  >
                    <option value="">Selecione</option>
                    {material &&
                      material.map((id_material) => (
                        <option key={id_material.id} value={id_material.id}>
                          {id_material.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2} className="mb-3">
                <Form.Group controlId="formDescricao">
                  <Form.Label>Quantidade</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0"
                    value={quantidade}
                    onChange={handleQuantidade}
                    ref={inputRefs.Quantidade}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default MateriaisOrdemRegister;
